var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(_vm.title) ? _c('div', {
    staticClass: "Polaris-Card__SectionHeader"
  }, [_c('polaris-subheading', {
    attrs: {
      "tag": "h3"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-92ecb9b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92ecb9b4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisCardSection.vue
// module id = 125
// module chunks = 0